import { BaseStyles, ThemeProvider, useCachedTheme } from '@kc-console/common-ui';
import {
  GlobalLoaderProvider,
  ModalProvider,
  NotificationProvider,
  ToastProvider,
} from '@kc-console/context';

import { FontFaceDefinitions } from '../../utils/fonts';
import AppBoundary from '../AppBoundary';
import ErrorWrapper from '../AppBoundary/ErrorWrapper';
import { LayoutPartialLoader } from '../Loader';
import ModalRenderer from '../ModalRenderer';
import PanelInitializer from '../PanelInitializer';
import V2Initializer from '../PanelInitializer/V2Initializer';
import { TaskManagerPanel } from '../TaskManager';
import GeneralLayout from './LayoutBase/GeneralLayout';

import type { CommonLayoutProps } from './types';

const AppLayout = ({ children, pageProps }: CommonLayoutProps) => {
  // TODO (@walter-24) 화면 모드에 따라 전환 로직 필요
  const theme = useCachedTheme('light');

  return (
    <>
      <ThemeProvider theme={theme}>
        <GlobalLoaderProvider
          InitialLoaderComponent={props => (
            <LayoutPartialLoader
              zIndex={theme.zIndex.globalLoader}
              contentZIndex={theme.zIndex.globalLoaderContent}
              {...props}
            />
          )}
        >
          <ToastProvider>
            <NotificationProvider>
              <ModalProvider>
                <FontFaceDefinitions />
                <BaseStyles />
                <AppBoundary pageProps={pageProps}>
                  <GeneralLayout pageProps={pageProps}>
                    <ErrorWrapper pageProps={pageProps}>{children}</ErrorWrapper>
                  </GeneralLayout>
                  <PanelInitializer />
                  <V2Initializer />
                  <ModalRenderer />
                  <TaskManagerPanel />
                </AppBoundary>
              </ModalProvider>
            </NotificationProvider>
          </ToastProvider>
        </GlobalLoaderProvider>
      </ThemeProvider>
    </>
  );
};

export default AppLayout;
